export default {
  setCurrent ({ commit }, user) {
    return commit('SET_CURRENT_USER', user.data)
  }
}
